const messages = {};

function importAll(r) {
  r.keys()
    .forEach((key) => {
      if (key.includes('index')) return;

      const [, locale, moduleName] = key.match(/(\w+)\/([\w-._\d]*?)\.js$/);
      if (!messages[locale]) messages[locale] = {};
      messages[locale][moduleName] = r(key).default;
    });
}

importAll(require.context('.', true, /\.js$/));

export default messages;
